export default "__VITE_ASSET__nWkZH0a1__"